export const regimeTributario = {
    enum: {
        LUCRO_REAL: {
            id: 1,
            nome: "Lucro Real"
        },
        LUCRO_PRESUMIDO: {
            id: 2,
            nome: "Lucro Presumido"
        },
        SIMPLES_NACIONAL: {
            id: 3,
            nome: "Simples Nacional"
        },
        LUCRO_ARBITRADO: {
            id: 4,
            nome: "Lucro Arbitrado"
        },
        IMUNES: {
            id: 5,
            nome: "Imunes"
        },
        ISENTAS: {
            id: 6,
            nome: "Isentas"
        },
        MEI: {
            id: 7,
            nome: "MEI"
        },
        PESSOA_FISICA: {
            id: 8,
            nome: "Pessoa Física"
        },
    },
    getById: (id) => {
        for(const value of Object.values(regimeTributario.enum)) {
            if(value.id == id) return value;
        }
        
        return null;
    }
}